import React from 'react';
import { Button, Stack, Tooltip } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../features/redux/store';
import { updateUserDetails } from '../../features/redux/userSlice';
import { updateUser } from '../../apiRequest/user';
import { GB, CZ } from 'country-flag-icons/react/3x2';
import { t } from '../../features/i18n';
import { useLanguage } from '../../features/i18n/LanguageProvider';


const LanguageSwitch: React.FC = () => {
  const dispatch = useDispatch();
  const userCode = useSelector((state: RootState) => state.user.userCode);
  const userName = useSelector((state: RootState) => state.user.userName);
  const userEmail = useSelector((state: RootState) => state.user.email);
  const userAvatar = useSelector((state: RootState) => state.user.avatar);
  const currentLang = useSelector((state: RootState) => state.user.lang);
  const { refreshLanguage, setLanguage } = useLanguage();

  const handleLanguageChange = async (newLang: string) => {
    if (!userCode || newLang === currentLang) return;

    try {
      const userInfo = {
        code: userCode,
        name: userName || '',
        email: userEmail || '',
        avatar: userAvatar || '',
        language: newLang,
      };
      await updateUser(userInfo);
      await dispatch(updateUserDetails({ lang: newLang }));
      
      // First update the language
      setLanguage(newLang);
      // Then refresh resources
      refreshLanguage();
    } catch (error) {
      console.error('Error updating language:', error);
    }
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Tooltip title={t('switch_to_czech')}>
        <Button 
          onClick={() => handleLanguageChange('cs')}
          sx={{
            minWidth: 'auto',
            padding: '4px',
            opacity: currentLang === 'cs' ? 1 : 0.6,
            color: 'white',
            '&:hover': { opacity: 0.8 }
          }}
        >
          <CZ title="Czech Republic" width="24" height="24" />
        </Button>
      </Tooltip>

      <Tooltip title={t('switch_to_english')}>
        <Button 
          onClick={() => handleLanguageChange('en')}
          sx={{
            minWidth: 'auto',
            padding: '4px',
            opacity: currentLang === 'en' ? 1 : 0.6,
            color: 'white',
            '&:hover': { opacity: 0.8 }
          }}
        >
          <GB title="United Kingdom" width="24" height="24" />
        </Button>
      </Tooltip>
    </Stack>
  );
};

export default LanguageSwitch;
